import axios from "axios";
import { ApiResponse } from "common/types/api";
import { Fonts, FontDownload } from "common/types/models";

/**
 * フォント一覧取得
 * @param governmentCode
 * @returns
 */
export async function ApiGetFonts(
  governmentCode: string
): Promise<ApiResponse<Fonts[]>> {
  const response = await axios.get(`/api/fonts`, {
    params: { governmentCode },
  });
  return response.data;
}

/**
 * フォントダウンロードURL取得
 * @param governmentCode
 * @param id
 * @returns
 */
export async function ApiGetFontDownload(
  governmentCode: string,
  id?: number
): Promise<FontDownload[]> {
  const response = await axios.get<FontDownload[]>(`/api/fonts/download`, {
    params: { governmentCode, id },
  });
  return response.data;
}

/**
 * フォントアップロード
 * @param governmentCode
 * @param file
 * @returns
 */
export async function ApiUploadFont(
  governmentCode: string,
  file: File
): Promise<ApiResponse<void>> {
  const formData = new FormData();
  formData.append("governmentCode", governmentCode || "");
  formData.append("file", file);
  const response = await axios.post("/api/fonts", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

/**
 * フォント削除
 * @param id
 * @returns
 */
export async function ApiDeleteFont(id: number): Promise<ApiResponse<void>> {
  const response = await axios.delete(`/api/fonts/${id}`);
  return response.data;
}
